import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Goals } from '@/widgets/Goals';
import { IS_TEST } from '@/shared/const';
import { LKHeader } from '@/widgets/LKHeader';
import { Stories } from '@/features/LK/Stories';
import { Disclaimer } from '@/features/Disclaimer';
import { ErrorModal } from '@/features/ErrorModal';
import { EmptyData } from '@/features/LK/EmptyData';
import { Typography } from '@/shared/ui/Typography';
import { getCookie } from '@/shared/lib/utils/getCookie';
import { Collectibles } from '@/features/LK/Collectibles';
import { FormSuccessModal } from '@/features/FormSuccessModal';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import { useAuth, useUserData, useUserStore } from '@/entities/User';
import { usePrepareLayout } from '@/shared/lib/hooks/usePrepareLayout';
import cls from './LK.module.scss';

export const LK = () => {
    const { isAuth, isNoAccess, isNoData, setIsAuth, setIsNoAccess } = useUserStore();
    const { mutate: getUserData } = useUserData();
    const { mutate: authenticate } = useAuth({
        onSuccess: () => {
            getUserData();
        },
    });
    const [searchParams] = useSearchParams('');
    const navigate = useNavigate();
    const isMobile = useResize() < 768;

    useEffect(() => {
        if (searchParams && searchParams.get('contracts')) {
            setIsAuth(true);
            setIsNoAccess(true);

            return;
        }

        const id = getCookie('userId');

        if (!isAuth && !id) {
            navigate('/');

            return;
        }

        if (!isAuth && id) {
            authenticate({ id });
        }
    }, []);

    usePrepareLayout();

    const isUserAllowed = !isNoData && !isNoAccess;

    const emptyDataLink = IS_TEST ? 'https://test-sbercloud.sberbank-insurance.ru/m2' : 'https://sberbank-insurance.ru/m2';

    return (
        <div className={cls.container}>
            <LKHeader hideUserControls={!isUserAllowed} />
            {isUserAllowed ? (
                <>
                    <Stories />
                    <Collectibles />
                    <Goals />
                    <Disclaimer className={cls.disclaimer} hideUnderButton={isMobile} hideStar />
                </>
            ) : (
                <EmptyData
                    subDescription={
                        <span>
                            Оставьте заявку на оформление договора страхования на сайте{' '}
                            <Typography as="a" variant="link" target="_blank" href={emptyDataLink}>
                                Сбербанк Страхование Жизни
                            </Typography>{' '}
                            или дождитесь окончания периода охлаждения для входа в личный кабинет.
                        </span>
                    }
                    title="Данные не найдены"
                    description="Возможно, вы еще не оформили договор или договор не начал действовать."
                />
            )}
            <ErrorModal />
            <FormSuccessModal />
        </div>
    );
};
